import { render, staticRenderFns } from "./unidade.vue?vue&type=template&id=27d159e6&scoped=true&"
import script from "./unidade.vue?vue&type=script&lang=js&"
export * from "./unidade.vue?vue&type=script&lang=js&"
import style0 from "./unidade.vue?vue&type=style&index=0&id=27d159e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d159e6",
  null
  
)

export default component.exports